import { AxiosResponse } from 'axios';
import { IPlanDTO } from '../shared/interfaces/plan-interfaces';
import api from './api';

interface IService {
  list: () => Promise<AxiosResponse<IPlanDTO>>;
  choosePlan: (planId: number) => Promise<AxiosResponse>;
}

const planService: IService = {
  list: () => api.get('/plan/'),
  choosePlan: (planId: number) => api.post(`/plan/${planId}/choose`),
};

export default planService;
